import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';
//
import { FaCopy } from 'react-icons/fa'; //

import { Input } from '../../../components/ui';
//
import { copySO, getOrderList } from '../../../api/services/orderService';
import { setShowLoading } from '../../../redux/systemInfo';
import { getCartList } from '../../../api/services/cartService';
import { setUserCartList } from '../../../redux/userCart';

const Title = styled.h1`
  width: 100%;
  font-size: 24px;
  margin-bottom: 1.5rem;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 20px;
    margin-bottom: 1rem;
  }
`;

const InputGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  margin: 2rem 0;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const InputLabel = styled.label`
  font-size: 14px;
  color: #444;
`;

const InputContainer = styled.div`
  width: 100%;
  border: 1px solid #ccc;
`;

const SearchButton = styled.button`
  width: 100%;
  padding: 12px;
  background-color: ${(props) => props.theme.colors.primaryBlue};
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin-bottom: 2rem;
  transition: background-color 0.2s;
  font-weight: 600;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    padding: 14px;
    font-size: 15px;
    margin-bottom: 1.5rem;
  }
`;

const OrderListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top: 1px solid #ddd;
  font-size: 14px;
  margin-top: 1rem;
  gap: 1rem;

  @media (max-width: 768px) {
    gap: 16px;
    padding: 0 4px;
  }
`;

const OrderListItem = styled.div`
  display: flex;
  padding: 16px 16px;
  width: 100%;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  font-size: 14px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
    padding: 20px 16px;
    background-color: #f9f9f9;
    border-radius: 8px;
    border: 1px solid #ddd;
  }
`;

const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  color: ${(props) => props.theme.colors.primaryText};
  width: 220px;
  min-width: 220px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    gap: 4px;
  }
`;

const CustPONumber = styled.div`
  font-weight: bold;
  color: ${(props) => props.theme.colors.primaryBlue};
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 0;
  }
`;

const OrderDate = styled.div`
  font-size: ${(props) => props.theme.fontSizes.small};
  color: ${(props) => props.theme.colors.secondaryText};

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

// 가운데 영역
const CenterSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    align-items: flex-start;
    gap: 8px;
  }
`;

const OrderNumber = styled.div`
  font-weight: bold;
  color: ${(props) => props.theme.colors.primaryBlue};
  margin-bottom: 4px;

  @media (max-width: 768px) {
    font-size: 15px;
    margin-bottom: 0;
  }
`;

const StatusText = styled.div`
  font-style: italic;
  color: ${(props) => props.theme.colors.menuText};

  @media (max-width: 768px) {
    font-style: normal;
    font-size: 14px;
    line-height: 1.6;
  }
`;

// 오른쪽 영역
const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media (max-width: 768px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-top: 12px;
    border-top: 1px solid #ddd;
  }
`;

const TotalAmount = styled.div`
  font-weight: bold;
  color: ${(props) => props.theme.colors.primaryBlue};
  margin-bottom: 4px;

  @media (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 0;
  }
`;

const ViewDetailLink = styled(Link)`
  font-size: ${(props) => props.theme.fontSizes.small};
  color: ${(props) => props.theme.colors.primaryBlue};
  text-decoration: none;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    font-weight: 600;
    padding: 8px 16px;
    background-color: ${(props) => props.theme.colors.primaryBlue};
    color: white;
    border-radius: 4px;

    &:hover {
      text-decoration: none;
      opacity: 0.9;
    }
  }
`;

const NoOrdersMessage = styled.div`
  text-align: center;
  color: ${(props) => props.theme.colors.secondaryText};
  font-size: 16px;
  padding: 2rem;
  border: 1px solid #eee;
  border-radius: 4px;

  @media (max-width: 768px) {
    padding: 1.5rem;
    font-size: 15px;
  }
`;

const CopyButton = styled.button`
  display: flex;
  background-color: ${(props) => props.theme.colors.primaryBlue};
  color: #fff;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 10px;
  border: none;
  border-radius: 4px;
  gap: 10px;
  cursor: pointer;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #2b2370;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 14px;
    font-size: 15px;
    margin-top: 8px;
  }
`;

const OrderView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.userInfo);

  const [orderList, setOrderList] = useState([]);
  const [filter, setFilter] = useState({
    from: '',
    to: '',
    orderNo: '',
    sku: '',
    address: '',
  });

  const getDbOrderList = async () => {
    const result = await getOrderList(userInfo.idCustomer, filter);
    setOrderList(result.orderList);
  };

  const getDbCartList = async () => {
    dispatch(setShowLoading({ showLoading: true }));
    if (userInfo.zipcode) {
      const result = await getCartList(
        userInfo.idCustomer,
        userInfo.zipcode,
        userInfo.idStore,
      );
      dispatch(setUserCartList({ cart_list: result.cartList }));
    }
    dispatch(setShowLoading({ showLoading: false }));
  };

  const handleCopyOrder = async (idSO) => {
    const result = await copySO(userInfo.idCustomer, idSO);
    if (result.is_success) {
      await getDbCartList();
    }
    navigate(`/checkout?from=${idSO}`);
  };

  return (
    <>
      <Title>Search Web Orders</Title>

      <InputGrid>
        <InputGroup>
          <InputLabel>From Date</InputLabel>
          <InputContainer>
            <Input
              type='date'
              placeholder='month/day/year'
              value={filter.from}
              onChange={(value) => {
                setFilter({
                  ...filter,
                  from: value,
                });
              }}
            />
          </InputContainer>
        </InputGroup>

        <InputGroup>
          <InputLabel>To Date</InputLabel>
          <InputContainer>
            <Input
              type='date'
              placeholder='month/day/year'
              value={filter.to}
              onChange={(value) => {
                setFilter({
                  ...filter,
                  to: value,
                });
              }}
            />
          </InputContainer>
        </InputGroup>

        <InputGroup>
          <InputLabel>Purchase Order Number</InputLabel>
          <InputContainer>
            <Input
              placeholder='Enter Purchase Order Number'
              value={filter.orderNo}
              onChange={(value) => {
                setFilter({
                  ...filter,
                  orderNo: value,
                });
              }}
            />
          </InputContainer>
        </InputGroup>

        <InputGroup>
          <InputLabel>SKU</InputLabel>
          <InputContainer>
            <Input
              placeholder='Enter Product SKU'
              value={filter.sku}
              onChange={(value) => {
                setFilter({
                  ...filter,
                  sku: value,
                });
              }}
            />
          </InputContainer>
        </InputGroup>
      </InputGrid>

      <InputGroup style={{ width: '100%', marginBottom: '2rem' }}>
        <InputLabel>Shipping Address1</InputLabel>
        <InputContainer style={{ width: '100%' }}>
          <Input
            placeholder='Enter Shipping Address1'
            value={filter.address}
            onChange={(value) => {
              setFilter({
                ...filter,
                address: value,
              });
            }}
          />
        </InputContainer>
      </InputGroup>

      <SearchButton onClick={getDbOrderList}>SEARCH</SearchButton>

      {orderList.length > 0 ? (
        <OrderListContainer>
          {orderList.map((order) => {
            return (
              <OrderListItem key={order.idSO}>
                <LeftSection>
                  <CustPONumber>Cust PO # {order.custPO}</CustPONumber>
                  <OrderDate>{order.orderDT}</OrderDate>
                </LeftSection>

                <CenterSection>
                  <OrderNumber>Order # {order.idSO}</OrderNumber>
                  <StatusText>
                    <strong>Status:</strong> {order.status}
                    <br />
                    <strong>Payment:</strong>{' '}
                    {order.paidStatus === '0'
                      ? 'UNPAID'
                      : order.paidStatus === '1'
                        ? 'PARTIALLY PAID'
                        : order.paidStatus === '2'
                          ? 'FULLY PAID'
                          : ''}
                  </StatusText>
                </CenterSection>

                <RightSection>
                  <TotalAmount>
                    Total: ${parseFloat(order.grandAmount).toFixed(2)}
                  </TotalAmount>
                  <ViewDetailLink to={`/order/${order.idSO}`}>
                    View Detail
                  </ViewDetailLink>
                </RightSection>

                <CopyButton
                  onClick={() => {
                    handleCopyOrder(order.idSO);
                  }}
                >
                  <FaCopy />
                  <div>Copy Order</div>
                </CopyButton>
              </OrderListItem>
            );
          })}
        </OrderListContainer>
      ) : (
        <NoOrdersMessage>No orders</NoOrdersMessage>
      )}
    </>
  );
};

export default OrderView;
